/**
 * Example values for schema fields of the upload page (template + on-page
 * example). Pure, schema-driven (no hardcoded domain).
 */
import type { SchemaField } from '@/types/dataset';

/**
 * A representative example value for a schema field, used both in the
 * downloadable template and in the on-page example. Kept TYPE-VALID: the sample
 * must survive the backend coercion (_coerce_email/int/date/...) so the
 * generated template actually imports. Falls back to a neutral placeholder for
 * free-text fields.
 */
export function exampleValueForField(field: SchemaField): string {
  switch (field.type) {
    case 'phone':
      // TASK-413 (AC-3): no leading "+" - Excel parses it as a formula start.
      // The backend normalizes "+7XXXXXXXXXX" and "8XXXXXXXXXX" the same way.
      return '89991234567';
    case 'telegram':
      return '@username';
    case 'email':
      return 'ivan@example.ru';
    case 'int':
    case 'integer':
    case 'number':
      return '1';
    case 'date':
      return '2026-01-01';
    case 'bool':
    case 'boolean':
      return 'true';
    case 'enum': {
      // enum fields may carry a `choices` array (not on the base interface).
      const choices = (field as { choices?: unknown }).choices;
      if (Array.isArray(choices) && choices.length > 0) {
        return String(choices[0]);
      }
      return 'Пример';
    }
    default: {
      const key = `${field.name} ${field.label}`.toLowerCase();
      if (key.includes('name') || key.includes('имя')) return 'Иван';
      return 'Пример';
    }
  }
}
